import { action, payload } from 'ts-action'

import { IFavorite } from 'models/Favorite'
import { IError, IPayload } from 'models/Global'

export const FavorerBusinessesFetching = action(
  'FavorerBusinessesFetching',
  payload<boolean>(),
)

export const GetFavorerBusinesses = action(
  'GetFavorerBusinesses',
  payload<IPayload<IFavorite[]>>(),
)

export const GetFavorerBusinessesErrors = action(
  'GetFavorerBusinessesErrors',
  payload<IError>(),
)

export const ClearFavorerBusinessesReducer = action(
  'ClearFavorerBusinessesReducer',
)
